"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "alghero": {
    "2167491b": [{
      "hkey": "27dc7927",
      "slug": "sa-segada",
      "name": "Sa Segada",
      "primary": true,
      "skipSearch": false
    }],
    "288a4630": [{
      "hkey": "ab050554",
      "slug": "tramariglio-pischina-salida",
      "name": "Tramariglio-Pischina Salida",
      "primary": true,
      "skipSearch": false
    }],
    "ec15cd2d": [{
      "hkey": "e41463b4",
      "slug": "alghero",
      "name": "Alghero",
      "primary": true,
      "skipSearch": false
    }],
    "san-segada": [{
      "hkey": "27dc7927",
      "slug": "sa-segada",
      "name": "Sa Segada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "serra-ona": [{
      "hkey": "e41463b4",
      "slug": "alghero",
      "name": "Alghero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "tramariglio": [{
      "hkey": "ab050554",
      "slug": "tramariglio-pischina-salida",
      "name": "Tramariglio-Pischina Salida",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ee343694": [{
      "hkey": "3280d4d5",
      "slug": "carmine-galboneddu-rio-calvia",
      "name": "Carmine-Galboneddu-Rio Calvia",
      "primary": true,
      "skipSearch": false
    }],
    "carmine-caragol": [{
      "hkey": "3280d4d5",
      "slug": "carmine-galboneddu-rio-calvia",
      "name": "Carmine-Galboneddu-Rio Calvia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "99114146": [{
      "hkey": "3dd92102",
      "slug": "pivarada",
      "name": "Pivarada",
      "primary": true,
      "skipSearch": false
    }],
    "pivarda": [{
      "hkey": "3dd92102",
      "slug": "pivarada",
      "name": "Pivarada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e809cd22": [{
      "hkey": "ef5864d7",
      "slug": "sant-agostino",
      "name": "Sant'Agostino",
      "primary": true,
      "skipSearch": false
    }],
    "sant-agostino-carrabuffas": [{
      "hkey": "ef5864d7",
      "slug": "sant-agostino",
      "name": "Sant'Agostino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;